module.exports = __webpack_public_path__ + "img/2-7-2.0c3f54e9.png";